import { apiService } from './api';
import {
  StockReconciliationDTO,
  StockReconciliationListDTO,
  StockReconciliationApprovalStatusDTO,
  StockReconciliationStatsDTO,
  CreateStockReconciliationRequest,
} from '../types';

const API = '/stock-reconciliations';

export const stockReconciliationService = {
  // ── CRUD ──────────────────────────────────────────────────────────────────

  getAll: (pageNumber = 1, pageSize = 50) =>
    apiService.get<{ data: StockReconciliationListDTO[]; pagination: { total: number; page: number; pageSize: number } }>(
      API, { pageNumber, pageSize }
    ),

  getById: (id: number | string) =>
    apiService.get<StockReconciliationDTO>(`${API}/${id}`),

  getStats: () =>
    apiService.get<StockReconciliationStatsDTO>(`${API}/stats`),

  create: (data: CreateStockReconciliationRequest) =>
    apiService.post<StockReconciliationDTO>(API, data),

  update: (id: number | string, data: Partial<CreateStockReconciliationRequest> & { items: CreateStockReconciliationRequest['items'] }) =>
    apiService.put<StockReconciliationDTO>(`${API}/${id}`, data),

  delete: (id: number | string) =>
    apiService.delete<boolean>(`${API}/${id}`),

  // ── Workflow ──────────────────────────────────────────────────────────────

  submit: (id: number | string, submittedByUserId: number) =>
    apiService.post<StockReconciliationApprovalStatusDTO>(`${API}/${id}/submit`, { submittedByUserId }),

  getApprovalStatus: (id: number | string) =>
    apiService.get<StockReconciliationApprovalStatusDTO>(`${API}/${id}/approvals`),

  approve: (approvalId: number, userId: number, comments?: string) =>
    apiService.post<StockReconciliationApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/approve`,
      { userId, comments }
    ),

  reject: (approvalId: number, userId: number, rejectionReason: string) =>
    apiService.post<StockReconciliationApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/reject`,
      { userId, rejectionReason }
    ),

  post: (id: number | string, postedByUserId: number) =>
    apiService.post<StockReconciliationDTO>(`${API}/${id}/post`, { postedByUserId }),

  cancel: (id: number | string, cancelledByUserId: number, cancellationReason?: string) =>
    apiService.post<StockReconciliationDTO>(`${API}/${id}/cancel`, { cancelledByUserId, cancellationReason }),
};
